import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('es'); // Default to Spanish for initial render
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    // Check if language is already saved
    const savedLang = localStorage.getItem('lang');
    if (savedLang && (savedLang === 'es' || savedLang === 'en')) {
      setLanguage(savedLang);
      setShowModal(false);
    } else {
      // First visit - show modal but keep Spanish as background
      setShowModal(true);
    }
  }, []);

  const selectLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('lang', lang);
    setShowModal(false);
  };

  const switchLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('lang', lang);
  };

  return (
    <LanguageContext.Provider value={{ language, selectLanguage, switchLanguage, showModal }}>
      {children}
    </LanguageContext.Provider>
  );
};
